import {User} from "../../../../../api/accessControl/User.ts";
import {useEffect, useState} from "react";
import {BackendApi} from "../../../../../api/api.ts";
import Shell from "../../../../../components/specific/Shell.tsx";
import {Subscription} from "./Subscription.tsx";
import {SubscriptionsTable} from "./SubscriptionsTable.tsx";
import LoadingFrame from "../../../../../components/LoadingFrame.tsx";

export default function SubscriptionsPage({currentUser}: { currentUser: User }) {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [subscriptionData, setSubscriptionData] = useState<Array<Subscription>>([]);
    const api = new BackendApi(currentUser.getToken())

    async function onLoad() {
        const response = await api.Business__mySubscriptions({business_id: currentUser.businesses[0]})
        setSubscriptionData(response)
        setIsLoading(false)
    }

    useEffect(() => {
        onLoad()
    }, []);

    if (!subscriptionData) return;

    return (
        <Shell currentUser={currentUser} isLoading={isLoading} title="Mijn abonnementen">
            <LoadingFrame isLoading={isLoading}>
                <SubscriptionsTable data={subscriptionData}/>
            </LoadingFrame>
        </Shell>
    )
} 
